import { render, staticRenderFns } from "./groupFitnessDashboardLabels.vue?vue&type=template&id=2bf8087d&scoped=true"
import script from "./groupFitnessDashboardLabels.vue?vue&type=script&lang=js"
export * from "./groupFitnessDashboardLabels.vue?vue&type=script&lang=js"
import style0 from "./groupFitnessDashboardLabels.vue?vue&type=style&index=0&id=2bf8087d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf8087d",
  null
  
)

export default component.exports